import Button from "../../components/Shared/Button"
import AddIcon from "../../components/Icons/AddIcon"
import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import AddNewMember from "../../components/Dashboard/Sales/AddNewMember"
import { GetAllSales } from "../../api/Sales/GetAllSales"
import SalesMemberCard from "../../components/Dashboard/Sales/SalesMemberCard"
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton"
const Sales = () => {
    const [showAddMember, setShowAddMember] = useState(false);
    const { data: SalesData } = useQuery({
        queryFn: GetAllSales,
        queryKey: ["sales"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const handleAddMemberSuccess = () => {
        setShowAddMember(false);
      };
    
    const sales = SalesData?.data
    return (
        <div>
            {showAddMember ? (
                <div className="space-y-4">
                    <DashboardInlineBackButton
                        label="Back to sales"
                        onClick={() => setShowAddMember(false)}
                    />
                    <AddNewMember onSuccess={handleAddMemberSuccess} />
                </div>
            ) : (

                <div>
                    <div className="flex justify-between items-center py-7">
                        <h1 className="text-burntBlack font-bold text-[32px]">Sales</h1>
                        <Button
                            onClick={() => setShowAddMember(true)}
                            className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                            variant="primary"
                        >
                            <AddIcon className="mr-1.5" />
                            Add New Account
                        </Button>
                    </div>
                    <div className="grid grid-cols-4 gap-7">
                        {sales?.map((Sales) => (
                            <SalesMemberCard salesId={Sales.id} img={Sales.img_url} name={`${Sales.firstName} ${Sales.lastName}`} email={Sales.email} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Sales
